/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import markCheckedByStringMatch from '@xmanscript/utils/markCheckedByStringMatch';
import splitArrayIntoChunks from '@xmanscript/utils/splitArrayIntoChunks';
import { cn } from '@/utils';
import Checkbox from '../CheckBox';

interface CheckBoxOption {
  id: string;
  label: string;
  checked: boolean;
  [key: string]: any; // Add this line to allow indexing with a string
}

interface CheckBoxGroupProps {
  className?: string;
  value: string[];
  checkBoxOptions: CheckBoxOption[];
  choose?: string;
  onChange?: (selected: string[]) => void;
  rows?: number;
  id?: string;
}

export default function CheckBoxGroup({
  className,
  value,
  checkBoxOptions = [],
  choose = 'id',
  onChange,
  rows = 5,
  id,
}: CheckBoxGroupProps) {
  const [list, setList] = useState<CheckBoxOption[]>([]);

  const changeHandler = (obj: CheckBoxOption, val: boolean) => {
    setList((prev) => {
      const tempPrev = [...prev];
      const index = prev.findIndex((item) => item.id === obj.id);
      tempPrev[index].checked = val;
      if (onChange)
        onChange(
          tempPrev.reduce<string[]>((acc, item) => {
            if (item.checked) acc.push(item[choose as keyof CheckBoxOption]);
            return acc;
          }, []),
        );
      return tempPrev;
    });
  };

  useEffect(() => {
    if (value?.length) setList(markCheckedByStringMatch(checkBoxOptions, value, choose));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    setList(checkBoxOptions);
  }, [checkBoxOptions]);

  return (
    <div className="flex gap-4" id={id}>
      {splitArrayIntoChunks(list, rows).map((lst: CheckBoxOption[]) => (
        <div key={JSON.stringify(lst)} className={cn('w-full flex-col items-center justify-center gap-2', className)}>
          {lst.map((item) => (
            <div key={item.id} className="box flex min-h-[1.5rem] items-center justify-start gap-2">
              <Checkbox id={item.id} onCheckedChange={(e) => changeHandler(item, !!e)} checked={item.checked} />
              <label
                htmlFor={item.id}
                className="cursor-pointer text-sm font-medium leading-none text-gray-800 peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                {item.label}
              </label>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
